/* eslint-disable max-lines */
export default {
  title: {
    notFound: 'No encontrada',
    error: 'Error',
    legal: 'Legal',
    login: 'Login',
    dashboard: 'Bienvenido',
    manageAppointment: 'Gestionar cita previa',
    averages: 'Averías',
    damages: 'Siniestros',
    maintenanceRevision: 'Mantenimiento/Revisión',
    historyOfInterventions: 'Histórico de Intervenciones',
    appointmentAverages: 'Averías',
    appointmentGlassWindows: 'Lunas',
    appointmentRevision: 'Revisión',
    appointmentTyres: 'Neumáticos',
    glasswindows: 'Lunas',
    tyres: 'Neumáticos',
    changePassword: 'Cambiar contraseña',
    contactAccount: 'Contáctanos',
    personalInformation: 'Información personal',
    vehicleInformation: 'Información del vehículo',
    cardFuel: 'Tarjeta carburante',
    fines: 'Multas',
    returnCar: 'Devolución de Vehículo',
    incidentsDGT: 'Incidencias DGT',
    pointsInterest: 'Puntos de interés',
    roadsideAssistance: 'Asistencia en carretera',
    accidentManagement: 'Gestión de accidentes',
    contactAssistance: 'Contáctanos',
    remember: 'Recordar contraseña',
    verifyPass: 'Verificar contraseña',
    newUser: 'Nuevo usuario',
    confirmData: 'Confirmación de datos',
    notifications: 'Notificaciones',
    titleHistorical: 'Próximas intervenciones',
    myAyvens: 'My Ayvens',
    oidcCallback: 'Procesando...',
    accessDenied: 'Acceso denegado',
    titleModalExit: '¿Quieres salir de la aplicacion?',
    textConfirmMessage:
      'Hemos recibido tu petición, en breve contactaremos contigo para darte una respuesta',
    contactALD: 'Ayvens Contacto',
    address: 'Dirección',
    myVehicle: 'Mi Vehículo',
    graphicsTitleConsumption: 'Consumo de carburante (euros)',
    graphicsTitleLitres: 'Litros de carburante',
    graphicsTitleToll: 'Costes de peajes (euros)',
    priorAppointmentRevision: 'Cita Previa - Revisión',
    priorAppointmentTyres: 'Cita Previa - Neumáticos',
    priorAppointmentAverages: 'Cita Previa - Averías',
    priorAppointmentGlasswindows: 'Cita Previa - Lunas/Siniestros',
    documentation: 'Documentación',
    requestReplacementVehicle: 'Solicitar vehículo de Sustitución'
  },
  text: {
    roadsideAssistance1: 'Asistencia en carretera',
    roadsideAssistance2: 'Servicio de Asistencia 24: horas al día, 7 días a la semana.',
    roadsideAssistance3: 'Aviso grua',
    contactRoadsideAssistance1:
      'Contacte con nuestro Departamento de Atención al Cliente, donde podrá solicitar todos nuestros servicios en un único contacto. Estamos a su disposición 24 horas al día, los 365 días al año. Contará con un equipo profesional que atenderá sus necesidades, resolverá sus dudas y gestionará sus peticiones o incidencias.',
    contactRoadsideAssistance2: '913336717',
    returnCar1: 'Devolución de Vehículo',
    requestReplacementVehicle: 'Solicitar vehículo de Sustitución',
    returnCar2: 'Documentación a presentar cuando se devuelva el vehículo',
    returnCar3: 'Solicite Cita Previa para devolver su vehículo.',
    returnCar4: 'Permiso de circulación y Ficha de inspección técnica',
    returnCar5: 'Libro de mantenimiento y manuales',
    returnCar6: 'Todas las copias de las llaves del vehículo',
    returnCar7: 'Código de arranque y de radio',
    returnCar8: 'Carátula extraíble del equipo de audio',
    returnCar9:
      'Cualquier accesorio, elemento o documento que se entregó con el vehículo, o le han hecho llegar durante el período de renting.',
    returnCar10: '91 594 96 89',
    pointsInterest: 'Puntos de interés',
    incidentsDGT: 'Incidentes DGT',
    fines1: 'Multas',
    fines2: 'Gestionamos tus multas en caso de recibir una Sanción de Tráfico.',
    fines3: '91 594 96 89',
    notifications1: 'notificaciones no leídas',
    showAllNotifications: 'Ver todas las notificaciones',
    vehicleInformation1: 'Extras',
    vehicleInformation2: 'Opciones extra',
    vehicleInformation3: 'Características del vehículo',
    vehicleInformation4: 'Opciones',
    vehicleInformation5: 'Opciones accesibles',
    personalInformation1:
      'Completar o corregir aquí vuestros datos personales para poder hacer un uso completo de la la aplicación',
    personalInformation2:
      'Su dirección será utilizada en aquellos casos donde sea necesario hacer uso de su localización.',
    myAccountContact1: 'Tu pregunta',
    myAccountContact2:
      '¿Tienes alguna pregunta, queja o una petición de servicio relacionada con tu vehículo, contrato o servicios?',
    myAccountContact3: '¡Estamos a tu disposición!',
    myAccountContact4: 'Por favor, usa este formulario y te responderemos lo antes posible:',
    glassWindows1:
      'Para gestionar el siniestro o la sustitución, ponte en contacto con nosotros en el',
    glassWindows2: 'Debe comunicarnos el siniestro.',
    glassWindows3:
      'En caso de acto vandálico, deberá denunciar el hecho en comisaría de policía y adjuntarnos la denuncia a',
    glassWindows4: 'atencion.cliente@ayvens.com',
    glassWindows5: 'Gestión de Lunas',
    glassWindows6: '902 230 235',
    glassWindows7: '913336717',
    glassWindows8:
      'Para solicitar una Cita previa de Siniestros o Lunas por impacto o rotura, primero se debe abrir un parte. Para ello puede contactarnos directamente en:',
    historicalDetail1: 'Kilometros:',
    historicalDetail2: 'Tipo de Intervención:',
    historicalDetail3: 'Nº de Gestion:',
    historicalDetail4: 'Entrada taller:',
    historicalDetail5: 'Salida taller:',
    historicalDetail6: 'Sin Fecha',
    historicalDetail7: 'Taller:',
    historicalDetail8: 'Detalle:',
    changePasswordText: 'La nueva contraseña debe ser numerica con 6 digitos.',
    accidentManagement1: 'Gestión de Accidentes',
    accidentManagement2:
      'En Caso de accidente o robo, llámenos y le asesoraremos en todo lo necesario para gestionar un siniestro. Gestionaremos el expediente, peritación y reparación de su vehículo en nuestra red preferente de talleres.',
    accidentManagement3: 'Sus coberturas contratadas:',
    accidentManagement4: 'AutoSeguro - Serviplus Advanced',
    accidentManagement5: 'Asistencia en Carretera',
    accidentManagement6: 'Rellene todos los campos de la Declaración Amistosa de Accidente.',
    accidentManagement7:
      'Si no llega a un acuerdo con los implicados, no firme la Declaración Amistosa de Accidente.',
    accidentManagement8:
      'En caso de conflicto tiene la posibilidad de avisar a la autoridad y solicitar el nº de atestado y autoridad interviniente.',
    accidentManagement9:
      'Si no puede rellenar la Declaración Amistosa de Accidente, deberá anotar:',
    accidentManagement10:
      'Fecha, lugar, descripcion del accidente, daños ocasionados y conductor contrario.',
    accidentManagement11:
      'Datos de todos los implicados. Imprescindible matrícula, póliza y compañía.',
    accidentManagement12:
      'Tomar nota de los datos de los posibles testigos (Nombre, D.N.I. y Teléfono)',
    accidentManagement13:
      'Recopile el mayor número de datos que le sea posible, tanto de vehículos como de objetos que hayan sido dañados a consecuencia del accidente.',
    accidentManagement14:
      'En caso de que el accidente se produzca en alguna gasolinera, parking, túnel de lavado, etc..., debe solicitar hoja de reclamación, póliza y compañía aseguradora del del mismo.',
    accidentManagement15:
      'En caso de que alguno de los implicados esté ausente, recuerde que no debe marcharse del lugar sin verificar si se han ocasionado daños, facilitando sus datos de contacto a los afectados.',
    accidentManagement16:
      'Tenga en cuenta que un estacionamiento indebido, el exceso de velocidad o cualquier otra infracción no determina la culpa en un accidente. Por lo tanto, no asuma responsabilidad en el accidente basándose en esos conceptos.',
    accidentManagement17:
      'Si tiene contratado el seguro con Ayvens: Cuando tenga todos los datos del incidente, comuníquelo lo antes posible a AYVENS SPAIN MOBILITY SOLUTIONS, S.A.U. a través del ',
    accidentManagement19: 'e-mail',
    accidentManagement20:
      ', y así agilizaremos la tramitación con la compañía y la reparación de los daños ocasionados en su vehículo.',
    accidentManagement21:
      'Si tiene contratado el seguro con Ayvens: Ante cualquier duda contacte con nuestro Departamento de Tramitación.',
    accidentManagement22:
      'Si tiene contratado el seguro con Ayvens: Cumplimente el parte y envíelo ',
    accidentManagement23: 'al email',
    accidentManagement24:
      '. Envíe el parte de accidentes antes de 24H si hay lesionados o un tercer involucrado.',
    accidentManagement25: ' Realice inmediatamente la denuncia y envíela ',
    accidentManagement26: `Gestione el parte de robo con la compañía aseguradora (acudiendo a 'Gestión de Siniestros')`,
    accidentManagement27:
      'Solicite el servicio de asistencia en carretera directamente desde el menú principal de esta aplicación.',
    vehicleContractInfoMissing: 'No hay información de contrato',
    textReplacementVehicle:
      'Para solicitar el servicio de Vehículo de sustitución, le vamos a solicitar que nos facilite la matrícula del vehículo sobre el que se hace la solicitud:',
    textVehicleData: 'Datos de su vehículo',
    textDriverUserData: 'Datos del Conductor / Usuario',
    textRepairShopDetails: 'Datos del taller reparador',
    textWorkshopDataManagement: 'Datos del taller y gestión',
    textAdditionalComments: 'Comentarios adicionales',
    textAuthorizationAccessoriesAssembly:
      'Para continuar con la gestión, por favor, póngase en contacto con su responsable de flota, gracias.'
  },
  message: {
    generic: {
      checkAccess: 'Verificando acceso...',
      loadingData: 'Cargando datos...',
      loadingDocuments: 'Cargando documentos...',
      noData: 'No tenemos datos para mostrar'
    },
    error: {
      registerUser:
        'Lamentamos los inconvenientes al asociar tu vehículo. Nuestro equipo está trabajando para resolverlo. Por favor, contacta al administrador para obtener asistencia. Nos pondremos en contacto contigo lo antes posible para brindarte una solución.',
      userNotFound: 'Su email no existe. Por favor, contacte con ALD.',
      oidcLoginError: 'Ups... ¡Algo salió mal en el inicio de sesión!',
      oidcLogoutError: 'Ups... ¡Algo salió mal en el cierre de sesión!',
      accessDeniedTitle: 'Acceso denegado',
      accessDeniedText:
        'No tiene permisos para acceder a la aplicación. Por favor, póngase en contacto con su administrador.',
      accessDeniedReturn: 'Regresar a la página principal',
      noNextInterventions2: '¡No hay próximas intervenciones!',
      noNextInterventions: 'Todavía no hay intervenciones realizadas para este servicio.',
      updateKms:
        'Error al actualizar los kilómetros, puede intentarlo nuevamente pasado unos minutos.',
      iframeError: 'Se ha producido un error al cargar la página, inténtelo de nuevo refrescando'
    },
    success: {
      updateKms: 'Los kilómetros han sido actualizados!'
    }
  },
  language: {
    en: 'Inglés',
    es: 'Español'
  },
  ui: {
    button: {
      legal: {
        cookies: 'Cookies',
        privacy: 'Privacidad',
        legal: 'Legal'
      },
      language: {
        en: 'EN',
        es: 'ES'
      },
      login: 'Entrar',
      cancel: 'Cancelar',
      accept: 'Aceptar',
      goMaps: 'Ir allí',
      emailInsurance: 'atencion.cliente@ayvens.com',
      updateKms: 'Actualizar kms',
      update: 'Actualizar',
      close: 'Cerrar',
      requestDocuments: 'Solicitar documentos',
      request: 'Solicitar',
      send: 'Enviar'
    },
    label: {
      email: 'Email',
      password: 'Contraseña',
      newPassword: 'Nueva contraseña',
      repeatPassword: 'Repita contraseña',
      repeatNewPassword: 'Repita Nueva contraseña',
      rememberPassword: 'Recordar Contraseña',
      rememberMe: 'Recuerdame',
      oldPassword: 'Antigua contraseña',
      plate: 'Matrícula',
      dni: 'DNI',
      dniNie: 'DNI/NIE',
      name: 'Nombre',
      lastName: 'Apellido',
      lastNameTwo: 'Segundo Apellido',
      mobilPhone: 'Telefono Móvil',
      labPassword: 'Contraseña',
      repitPassaword: 'Repite contraseña',
      address: 'Dirección',
      number: 'Numero',
      postalCode: 'Codigo postal',
      message: 'Mensaje',
      provinces: 'Provincias',
      province: 'Provincia',
      population: 'Población',
      country: 'País',
      town: 'Municipio',
      moreData: 'Datos compl.',
      typeRoad: 'Tipo de vía',
      select: 'Seleccione',
      advice: '¡Aviso importante!',
      plateNumber: 'Matrícula',
      brand: 'Marca',
      model: 'Modelo',
      version: 'Version',
      lastKm: 'Kilometros actuales',
      registrationDate: 'Fecha de matriculación',
      startContractDate: 'Fecha inicio contrato',
      finishContractDate: 'Fecha fin contrato',
      realKm: 'Kilometros contratados',
      lastKmDate: 'Fecha KM.a fin de contrato',
      motDate: 'Fecha proxima ITV',
      fuel: 'Carburante',
      wheels: 'Neumaticos',
      contract: 'Contrato Nº',
      time: 'Tiempo de garantia',
      user: 'Usuario',
      kms: 'Kilómetros',
      typeAccessory: 'Tipo de accesorio',
      countryVisit: 'País a visitar',
      haveNive: '¿Tiene NIVE?',
      documents: 'Documentos',
      textCategory: 'El tipo de vehículo de sustitución que se le asignará es ',
      category: 'Categoría ',
      typeImmobilization: 'Tipo de inmovilización',
      currentVehicleLocation: 'Ubicación actual del vehículo',
      emailAddress: 'Correo electrónico',
      workshopName: 'Nombre del taller',
      location: 'Localidad',
      contactPhoneNumber: 'Telefono de contacto',
      preferredLocation: 'Localidad de preferencia para la reserva',
      exactKilometers: 'Kilómetros exactos',
      deliveryAddress: 'Dirección de entrega',
      typeRepairs: 'Tipo de reparación',
      actualDateEntryWorkshop: 'Fecha real de entrada en taller',
      serviceWhichIncidentOccurred: 'Servicio sobre el que se produjo la incidencia',
      typeService: 'Tipo de servicio',
      reasonContact: 'Motivo de contacto',
      uploadDocuments: 'Subir documentos'
    },
    menu: {
      home: 'Home',
      myAccount: 'Mi Cuenta',
      priorAppointment: 'Cita Previa',
      roadsideAssistance: 'Asistencia en carretera',
      historyOfInterventions: 'Histórico de Intervenciones',
      otherSections: 'Otros Servicios',
      personalInfo: 'Información personal',
      vehicleInfo: 'Información del vehículo',
      changePassword: 'Cambiar contraseña',
      exitApp: 'Salir',
      requestPriorAppointment: 'Solicitar cita previa',
      managePriorAppointment: 'Gestionar cita previa',
      processAccident: 'Gestión de accidentes',
      maintenanceRevision: 'Mantenimiento / Revisión',
      maintenance: 'Mantenimiento',
      tyres: 'Neumáticos',
      averages: 'Averías',
      damages: 'Siniestros',
      glassWindow: 'Lunas/Siniestros',
      address: 'Dirección',
      additional: 'Extras',
      vehicleInformation: 'Información vehículo',
      options: 'Opciones',
      accident: 'Qué hacer en caso de accidente',
      heist: 'Robo',
      immobilizedVehicle: 'Vehículo inmovilizado',
      incidentsDGT: 'Incidencias DGT',
      interestingPoints: 'Puntos de interés',
      cardFuel: 'Tarjeta carburante',
      fines: 'Multas',
      revision: 'Revisión',
      vehicleReturn: 'Devolución del vehículo',
      requestReplacementVehicle: 'Solicitar vehículo de Sustitución',
      legal: 'Aviso Legal',
      dataPrivacy: 'Privacidad de Datos',
      cookies: 'Cookies',
      appointment: 'Cita Previa',
      assistance: 'Asistencia',
      otherServices: 'Otros Servicios',
      contact: 'Contacto',
      undefined: 'No definido',
      documentation: 'Documentación',
      foreignNational: 'Autorización Extranjero',
      serCard: 'Tarjeta SER',
      authorizationDepositExit: 'Autorización salida depósito',
      authorizationAccessoriesAssembly: 'Autorización montaje de accesorios'
    },
    links: {
      newUser: 'Nuevo usuario',
      forgetPassword: '¿Olvidaste tu contraseña?',
      nextContinue: 'Continuar',
      seeAllNotifications: 'Ver todas las notificaciones',
      noHaveAccount: '¿No tienes cuenta?',
      signup: 'Regístrate',
      emailService: 'atencion.cliente@ayvens.com',
      phoneService: '91 333 67 17',
      emailSac: 'atencion.cliente@ayvens.com'
    },
    placeholder: {
      showFilesModal: {
        title: 'Documentos subidos',
        error: 'Error al cargar los documentos'
      },
      showFiles: 'Ver documentos'
    },
    accordionText: {
      myCar: {
        vehicleContractInfo: 'Datos del contrato'
      }
    },
    table: {
      date: 'Fecha',
      amount: 'Importe',
      type: 'Tipo',
      kilometers: 'Kilómetros',
      action: 'Acción'
    },
    tabs: {
      graphics: 'Gráficas',
      table: 'Tabla'
    },
    charts: {
      filters: {
        all: 'Todo',
        lastWeek: 'Última semana',
        lastMonth: 'Último mes',
        lastYear: 'Último año'
      },
      labels: {
        liters: 'Litros',
        spent: 'Gasto'
      }
    },
    modals: {
      operationId: 'ID de operación',
      date: 'Fecha'
    },
    select: {
      complaint: 'Queja',
      serviceRequest: 'Petición de Servicio'
    }
  },
  literals: {
    newUserScreen:
      'Introduce la dirección de correo electrónico del usuario y la matrícula que quiere asociar.',
    rememberPasswordScreen:
      ' Introduce tu correo electrónico y te enviaremos una contraseña provisional, recuerda que tiene una vigencia de 24 horas y debes cambiarla la primera vez que accedas.',
    confirmDataScreenNewUser: 'Confirma que tus datos sean correctos.',
    newPasswordConfirmDataScreen: 'Tu nueva contraseña debe contener 6 números',
    noUnreadNotifications: 'No hay notificaciones sin leer',
    noUpcomingInterventions: 'No hay próximas intervenciones',
    nextRevisionItv: 'Próxima ITV',
    kmYear: 'Km/Año',
    lastKnownKms: 'Últimos Kms. Conocidos',
    kmEndContract: 'Fin contrato',
    periodOfValidity: 'Vigencia de contrato',
    months: 'meses',
    mapsliterals1: 'Por defecto toma la dirección del móvil, si se ha configurado previamente',
    myVehicleInfo: 'No tenemos información de un vehículo para mostrar',
    notEmailLogin: 'El email no aparece registrado en nuestra base de datos.',
    pleaseContact: 'Por favor, póngase en contacto con su asesor.',
    temporalPassword: 'Su contraseña temporal ha sido enviada con éxito.',
    temporalPasswordError: 'Error al enviar el email.',
    reviewEmail:
      'Por favor, revise su email y utilice la contraseña para acceder a My Ayvens. Recuerde debe de cambiar su contraseña en un plazo de 24 horas, en "Mi cuenta / Cambiar contraseña"',
    tryAgainLater: 'Por favor, inténtelo de nuevo más tarde.',
    confirmDataDescription:
      'Si los datos son correctos y estás de acuerdo, por favor acepta las condiciones de uso.',
    passwordType: 'Tu nueva contraseña debe contener 6 números',
    acceptThe: 'Acepto los',
    termAndConditionsUse: 'Términos y condiciones de uso',
    confirmReadPolicy: 'Confirmo que he leído la',
    policyAndPrivacityData: 'Política y privacidad de datos',
    confirmYourData: 'Confirma tus datos personales.',
    textConfirmData:
      'Es necesario mantener tus datos actualizados para poder comunicarnos contigo para darte el servicio. Si detectas algún dato erróneo por favor contactarnos por teléfono o por correo electrónico.',
    passwordsNotMatch: 'Las contraseñas no coinciden',
    changePassword: 'Cambio de contraseña',
    changePasswordError: 'Cambio de contraseña fallido',
    changedPasswordSuccess:
      'Contraseña cambiada correctamente, ahora puedes acceder a la aplicación con tu nueva contraseña.',
    confirmInformation: 'Confirmación de datos',
    confirmationDriverError: 'Error al confirmar los datos del conductor',
    confirmationDriverSuccess: 'Sus datos han sido confirmados correctamente',
    updateProfileError: 'Error al actualizar el perfil',
    updateProfileSuccess: 'Su perfil ha sido actualizado.',
    updateAvatarSuccess: 'Imagen de perfil actualizada.',
    updateAvatarError: 'Error al actualizar la imagen de perfil.',
    genericErrorCall: 'Error en la solicitud realizada.',
    errorNewUser: 'Error al crear el usuario',
    plateNotAssociatedDriver:
      'La matrícula introducida no está asociada al conductor, por favor contacte con atención al cliente.',
    realKm: 'KM Actuales',
    registrationDate: 'Fecha alta',
    fuel: 'Combustible',
    finishWarrantyDate: 'Fin Garantía',
    servicesWeels: 'Servicio Neumáticos',
    fileUploader: {
      maxFilesExceeded: 'No puedes seleccionar más de {maxFiles} archivos.',
      fileSizeExceeded: 'El archivo {fileName} excede el tamaño permitido de {maxSize}MB.',
      totalSizeExceeded:
        'No se ha podido cargar el archivo porque supera el limite establecido de {maxSize}MB',
      processError: 'Error procesando el archivo.',
      warningMaxFiles: 'Seleccione un máximo de {maxFiles} archivos.',
      warningTotalSize: 'El peso total no debe superar {maxSize}MB.',
      warningGeneric: 'Seleccione un archivo o un conjunto de ellos.',
      badgeMaxFiles: 'Archivos: {preloadedFiles} / {maxFiles}',
      badgeTotalSize: 'Tamaño: {sizePreloaded} / {maxWeightPreloaded}MB'
    },
    haveNive:
      'NIVE es un número de 32 dígitos, que es como el DNI de un coche y sustituye a la antigua ficha técnica en papel de color verde. Para saber si tu vehículo tiene NIVE debe venir indicado en la Ficha técnica como se indica en la imagen de ejemplo. Pulsa la imagen para ampliarla.'
  }
};
